export class OrderedTaskStepProgress {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get step() {
        return this.parent;
    }
    get stepEval() {
        return this.step.stepEval;
    }
    get isStepCompleted() {
        return this.stepEval.isNowCorrectlySelected || this.stepEval.attemptsNumber >= this.step.task.numberOfTries;
    }
    get isStepFinished() {
        if (!this.isStepCompleted)
            return false;
        if (!this.stepEval.state.latestSelectionEvent)
            return false;
        if (this.step.context.app.appClock.clock_250.tickingTime <= this.stepEval.state.latestSelectionEvent.appTime + 1500) {
            return false;
        }
        return true;
    }
}
